import "./assets/scss/themes.scss"


import "./assets/scss/tenant-overrides.scss"
import "./assets/css/tailwind.css"
import "./assets/css/shell-modern.css"
import "./assets/css/empresas-acomodo.css"

import Route from "./routes"
import { ErrorBoundary } from "./components/ErrorBoundary"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "sonner"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  },
})

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Route />
        <Toaster position="top-right" richColors />
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
